import './BetListNg.less';

import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import i18n from '@i18n';
import Immutable, { fromJS, List } from 'immutable';
import PropTypes from 'prop-types';
import BetNg from './BetNg';
import { betbookCreateAnalysisBetIds$ } from 'nike-ui/src/components/betbook/subs';
import {
    allPicksChosen$,
    cashinClosingModeActive$,
    cashinOddsChosenPicks$
} from 'nike-ui/src/components/ticketus/subs';
import { getOfferEventualTotals } from '@/cashins/handlers';
import { toggleChosenPicks, toggleDisabledPicks } from 'nike-ui/src/components/ticketus/handlers';
import { cashinOfferByTicketId$$ } from 'nike-ui/src/components/turboLive/components/cashin/subs';
import { logClosePickCheckbox } from 'nike-ui/src/common/logging/cashin/log';
import { accountUserData$ } from '@/account/subs';

function BetListNg({ ticket, bets }) {
    const { subscribe } = useReframe();
    const ticketId = ticket.get('ticketId');
    const source = ticket.get('source');

    const createAnalysisBetIds = subscribe(betbookCreateAnalysisBetIds$);
    const cashinOffer = subscribe(cashinOfferByTicketId$$(ticketId));
    const cashinClosingModeActive = subscribe(cashinClosingModeActive$(ticketId));
    const cashinClosingBetIds = subscribe(cashinOddsChosenPicks$(ticketId));
    const allPicksChosen = subscribe(allPicksChosen$(ticketId));
    const { idZak: customerId } = subscribe(accountUserData$);
    const currentUserTicket = ticket.get('customerId') === customerId;

    useEffect(() => {
        if (cashinClosingModeActive && !allPicksChosen) {
            dispatch(getOfferEventualTotals(ticket, cashinOffer, cashinClosingBetIds));
        }
    }, [cashinClosingModeActive, cashinOffer, cashinClosingBetIds, ticketId, allPicksChosen, ticket]);

    if (!bets || bets.size === 0) {
        return <div className="ticket-detail-betslist-empty">{i18n('ticketus.ticket.matchDataMissing')}</div>;
    }

    function getCashinPickData(betId) {
        return cashinOffer?.picks.find(pick => +pick.betId === betId);
    }

    const handleCashinClosingClick = bet => {
        const pick = getCashinPickData(bet.get('betId'));
        const selectionCode = pick?.selectionCode;
        const betId = bet.get('betId');
        logClosePickCheckbox({ ticketId, betId, offer: fromJS(cashinOffer), pick, enabled: true });
        dispatch(toggleChosenPicks({ ticketId, betId, selectionCode }));
    };

    const handleToggleDisabledPick = bet => {
        const pick = getCashinPickData(bet.get('betId'));
        const selectionCode = pick?.selectionCode;
        const betId = bet.get('betId');
        logClosePickCheckbox({ ticketId, betId, offer: fromJS(cashinOffer), pick, enabled: false });
        dispatch(toggleDisabledPicks({ ticketId, betId, selectionCode }));
    };

    return (
        <div className="ticket-detail-betlist">
            {bets.map(bet => (
                <BetNg
                    bet={bet}
                    key={bet.get('betId')}
                    ticketId={ticketId}
                    createAnalysisBetIds={createAnalysisBetIds}
                    source={source}
                    currentUserTicket={currentUserTicket}
                    handleCashinClosingClick={handleCashinClosingClick}
                    handleToggleDisabledPick={handleToggleDisabledPick}
                />
            ))}
        </div>
    );
}

BetListNg.propTypes = {
    ticket: PropTypes.instanceOf(Immutable.Map),
    bets: PropTypes.instanceOf(List)
};

export default BetListNg;
